export const reformatDateString = (dateString: string): string => {
  // Define the date separators
  const separators = ['/', '-'];
  let dateParts;

  // Loop through the separators to find which one is used in the dateString
  for (const separator of separators) {
    if (dateString.includes(separator)) {
      dateParts = dateString.split(separator);
      break;
    }
  }

  // If no separator was found, return the original dateString
  if (!dateParts) return dateString;

  // If the date is in the correct format, reformat it to YYYY/MM/DD
  if (
    dateParts.length === 3 &&
    dateParts[2].length === 4 &&
    dateParts.every((part) => !isNaN(Number(part)))
  ) {
    return `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`;
  }

  // If the date is not in the correct format, return the original dateString
  return dateString;
};

export const convertStringToDate = (
  dateString: string | object | null
): Date | null | undefined => {
  // If the dateString is null or undefined, return null
  if (!dateString) {
    return null;
  }

  // If the dateString is a Date object, return a new Date object with the same time
  if (dateString instanceof Date) {
    return new Date(dateString.getTime());
  }

  // If the dateString is a string, process it depending on its format
  if (typeof dateString === 'string' && dateString.length > 0) {
    let tempDate;

    // Define the date formats and their corresponding handling functions
    const dateFormats = {
      'DD-MM-YYYY': () => {
        const dateParts = dateString.split('-');
        return new Date(+dateParts[2], +dateParts[1] - 1, +dateParts[0]);
      },
      DDMMYYYY: () => {
        return new Date(+dateString.slice(4), +dateString.slice(2, 4) - 1, +dateString.slice(0, 2));
      },
      OTHER: () => {
        const reformattedDateString = reformatDateString(dateString);
        const dateWithoutTimeZone = reformattedDateString.replace(/GMT.*$/, '').trim();
        const date = new Date(dateWithoutTimeZone);
        if (isNaN(date.getTime())) {
          return null;
        }
        return date;
      },
    };

    // Determine the format of the dateString and process it accordingly
    switch (true) {
      case /^\d{2}-\d{2}-\d{4}$/.test(dateString):
        tempDate = dateFormats['DD-MM-YYYY']();
        break;
      case /^\d{8}$/.test(dateString):
        tempDate = dateFormats['DDMMYYYY']();
        break;
      case dateString.includes('/') || dateString.includes('-'):
        tempDate = dateFormats['OTHER']();
        break;
      default:
        return null;
    }

    // Adjust the date to the local timezone
    if (tempDate) {
      const localOffset = tempDate.getTimezoneOffset() * 60 * 1000;
      const adjustedDate = new Date(tempDate.getTime() + localOffset);
      return adjustedDate;
    }
  }

  // If the dateString is an object, try to convert it to a date
  if (typeof dateString === 'object') {
    const timeValue = dateString.valueOf();
    if (typeof timeValue === 'number') {
      return new Date(timeValue);
    }
  }

  return null;
};
